/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import { Tabs, Form, Button, message, Modal, Card, Table } from "antd";
import type {
  Student,
  Teacher,
  AttendanceRule,
  AttendanceStatus
} from "../../../types";
import { format } from "date-fns";
import DataTable from "./components/DataTable";
import QRScanner from "./components/QRScanner";
import IDCard from "./components/IDCard";
import { Link } from "react-router-dom";
import TooltipOption from "../../../core/common/tooltipOption";
import { all_routes } from "../../router/all_routes";
import QRCodeExpiryTab from "./pages/QRCodeExpiryTab";
import QRCodeExpiryTabNew from "./pages/QRCodeExpiryTab copy";
// import AdminScanAttendance from "./components/AdminScanAttendance";
import { _get, _post, _postnew } from "../../Utils/Helper";
import AdminAttendanceScanner from "./components/AdminAttendanceScanner";

const AdminAttendance: React.FC = () => {
  const routes = all_routes;
  const [activeTab, setActiveTab] = useState("1");
  const [scannedData, setScannedData] = useState<any>(null);
  const [showScannedData, setShowScannedData] = useState(false);
  const [attendanceData, setAttendanceData] = useState<any[]>([]);

  const [selectedLocation, setSelectedLocation] = useState<{
    latitude: number;
    longitude: number;
  } | null>(null);

  const defaultRules: AttendanceRule[] = [];

  const submitAttendanceToDatabase = async (attendanceData: any) => {
    try {
      await _post("attendance", attendanceData);
      console.log("Attendance submitted successfully");
    } catch (error) {
      console.error("Error submitting attendance:", error);
      message.error("Failed to submit attendance. Please try again.");
    }
  };

  const handleAttendanceAction = (
    user: Student | Teacher,
    action: "checkIn" | "checkOut"
  ) => {
    const now = new Date();
    const timeStr = format(now, "HH:mm");
    let status: AttendanceStatus = "late";

    // Determine status based on time and attendance rules
    for (const rule of defaultRules) {
      if (timeStr >= rule.startTime && timeStr <= rule.endTime) {
        status = rule.type as AttendanceStatus;
        break;
      }
    }

    const attendanceData = {
      user,
      action,
      time: now,
      status,
      location: selectedLocation
    };

    // Submit to the database
    submitAttendanceToDatabase(attendanceData);

    message.success(
      `${action === "checkIn" ? "Checked in" : "Checked out"} successfully`
    );
  };

  const fetchAttendance = async (): Promise<void> => {
    try {
      _get(
        `attendance`,
        (result) => {
          setAttendanceData(result);
          message.success("Teacher data fetched successfully.");
        },
        (err) => message.error("Failed to fetch teacher data.")
      );
    } catch (err) {
      console.error("Error fetching attendance:", err);
      message.error("Failed to fetch attendance. Please try again.");
    }
  };

  useEffect(() => {
    fetchAttendance();
  }, []);

  //  // Handle attendance (check-in/out)
  //   const handleAttendance = (type: "check-in" | "check-out") => {
  //     if (!teacherData) {
  //       message.error("Teacher data is unavailable.");
  //       return;
  //     }

  //     const now = new Date().toISOString().slice(11, 19);
  //     const date = new Date().toISOString().split("T")[0];

  //     const payload = {
  //       name: teacherData.teacher_name,
  //       class: teacherData?.data?.class_name || "Unknown",
  //       role: teacherData?.data?.teacher_role || "Unknown",
  //       department: teacherData?.data?.department || "Unknown",
  //       date,
  //       [`${type.replace("-", "_")}_time`]: now, // Converts "check-in" to "check_in"
  //       check_out_time: now,
  //       status: type === "check-in" ? "Present" : "Checked Out",
  //       remarks:
  //         type === "check-in"
  //           ? "Checked in successfully"
  //           : "Checked out successfully",
  //     };

  //     const endpoint =
  //       type === "check-in" ? "attendance" : `attendance/${teacherData.id}`;
  //     const method = type === "check-in" ? _post : _put;

  //     method(
  //       endpoint,
  //       payload,
  //       () => {
  //         message.success(
  //           `${type === "check-in" ? "Checked in" : "Checked out"} successfully.`
  //         );
  //         fetchAttendance();
  //       },
  //       () =>
  //         message.error(
  //           `Failed to ${type === "check-in" ? "check in" : "check out"}.`
  //         )
  //     );
  //   };

  //   // QR Code Scanner: Adjusting the mode mapping
  //   const handleScanSuccess = (decodedText: string) => {
  //     const now = new Date().toISOString();
  //     const mode = "check-in"; // Define the mode variable
  //     try {
  //       const userData = JSON.parse(decodedText);

  //       if (userData.role !== "teacher") {
  //         message.error("This QR code does not belong to a teacher.");
  //         return;
  //       }

  //       const attendanceData = {
  //         name: userData.name,
  //         class: userData.class,
  //         role: userData.role,
  //         department: null,
  //         date: new Date().toISOString().split("T")[0],
  //         [`${mode?.replace("-", "_")}_time`]: now, // Converts "check-in" to "check_in"
  //         check_out_time: now,
  //         status: mode === "check-in" ? "Present" : "Checked Out",
  //         remarks:
  //           mode === "check-in"
  //             ? "Checked in via QR code."
  //             : "Checked out via QR code.",
  //       };

  //       _postnew(
  //         "attendance",
  //         attendanceData,
  //         () => {
  //           message.success(
  //             `${userData.name} ${
  //               mode === "check-in" ? "checked in" : "checked out"
  //             } successfully.`
  //           );
  //         },
  //         (err) => {
  //           console.error("Error saving attendance:", err);
  //           message.error("Failed to record attendance.");
  //         },
  //         true
  //       );
  //     } catch (error) {
  //       console.error("Invalid QR code format:", error);
  //       message.error("Invalid QR code format.");
  //     }
  //   };

  const studentColumns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Class", dataIndex: "class", key: "class" },
    { title: "Status", dataIndex: "status", key: "status" },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: Student) => (
        <div className="space-x-2">
          <Button onClick={() => handleAttendanceAction(record, "checkIn")}>
            Check In
          </Button>
          <Button onClick={() => handleAttendanceAction(record, "checkOut")}>
            Check Out
          </Button>
        </div>
      )
    }
  ];

  const teacherColumns = [
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "Class", dataIndex: "class", key: "class" },
    { title: "Role", dataIndex: "role", key: "role" },
    { title: "Date", dataIndex: "date", key: "date" },
    {
      title: "Check-In Time",
      dataIndex: "check_in_time",
      key: "check_in_time"
    },
    {
      title: "Check-Out Time",
      dataIndex: "check_out_time",
      key: "check_out_time"
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <span style={{ color: status === "Present" ? "green" : "red" }}>
          {status}
        </span>
      )
    },
    { title: "Remarks", dataIndex: "remarks", key: "remarks" },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: Teacher) => (
        <div className="space-x-2">
          <Button onClick={() => handleAttendanceAction(record, "checkIn")}>
            Check In
          </Button>
          <Button onClick={() => handleAttendanceAction(record, "checkOut")}>
            Check Out
          </Button>
        </div>
      )
    }
  ];

  const handleScanSuccess = async (
    decodedText: string,
    location?: GeolocationCoordinates
  ) => {
    try {
      const data = JSON.parse(decodedText);
      const scanTime = new Date();
      const scanTimeStr = format(scanTime, "HH:mm");

      let status: AttendanceStatus = "late";
      for (const rule of defaultRules) {
        if (scanTimeStr >= rule.startTime && scanTimeStr <= rule.endTime) {
          status = rule.type as AttendanceStatus;
          break;
        }
      }

      // Check if the scanned data is a student or teacher ID card
      if (data.type === "student" || data.type === "teacher") {
        const scanData = {
          ...data,
          scanTime,
          location,
          status
        };

        setScannedData(scanData);
        setShowScannedData(true);
        message.success(
          `${
            data.type === "student" ? "Student" : "Teacher"
          } ID card scanned successfully`
        );
      } else {
        // Handle general QR code scan
        const scanData = {
          ...data,
          scanTime,
          location,
          status
        };

        setScannedData(scanData);
        setShowScannedData(true);
        message.success("QR Code scanned successfully");
      }
    } catch (error) {
      message.error("Invalid QR Code");
    }
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            {/* <h3 className="page-title mb-1">Admin Attendance Dashboard</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Admin Attendance
                </li>
              </ol>
            </nav> */}
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <TooltipOption />
          </div>
        </div>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={[
            {
              key: "1",
              label: "Student Attendance Report",
              children: (
                <div className="space-y-6">
                  <DataTable
                    data={[]}
                    columns={studentColumns}
                    selectable
                    onSelectionChange={(selected) =>
                      console.log("Selected:", selected)
                    }
                  />
                </div>
              )
            },
            {
              key: "2",
              label: "Attendance Details",
              children: (
                <>
                  <DataTable
                    data={attendanceData}
                    columns={teacherColumns}
                    selectable
                  />
                  {/* <Table
                    dataSource={attendanceData}
                    columns={teacherColumns}
                    rowKey="id"
                    bordered
                  /> */}
                </>
              )
            },
            // {
            //   key: "3",
            //   label: "QR Scanner",
            //   children: (
            //     <div className="max-w-2xl mx-auto">
            //       <QRScanner
            //         onScanSuccess={handleScanSuccess}
            //         requireLocation
            //       />
            //     </div>
            //   ),
            // },
            // {
            //   key: "4",
            //   label: "QR Scanner",
            //   children: (
            //     <div className="max-w-2xl mx-auto">
            //       <AdminScanAttendance onAttendanceRecorded={submitAttendanceToDatabase} />
            //     </div>
            //   ),
            // },
            {
              key: "3",
              // key: "5",
              label: "School QR Code SetUp",
              children: (
                <div className="max-w-2xl mx-auto">
                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <QRCodeExpiryTab />
                  </div>
                </div>
              )
            },
            {
              // key: "6",
              key: "4",
              label: "Qr Code Created for Attrendance",
              children: (
                <div className="max-w-2xl mx-auto">
                  <div className="bg-white rounded-lg shadow-lg p-6">
                    <QRCodeExpiryTabNew />
                  </div>
                </div>
              )
            },
            {
              key: "5",
              label: "QR Scanner",
              children: (
                <div className="max-w-2xl mx-auto">
                  <AdminAttendanceScanner />
                </div>
              )
            }
          ]}
        />
        <Modal
          title="Scanned Data"
          open={showScannedData}
          onCancel={() => setShowScannedData(false)}
          footer={null}
          width={800}
        >
          {scannedData && (
            <div className="space-y-6">
              {scannedData.type === "student" ||
              scannedData.type === "teacher" ? (
                <div>
                  <div className="mb-4">
                    <h3 className="text-lg font-semibold mb-2">
                      Scan Information
                    </h3>
                    <p>
                      <strong>Scan Time:</strong>{" "}
                      {format(scannedData.scanTime, "PPpp")}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      <span className="capitalize">{scannedData.status}</span>
                    </p>
                    {scannedData.location && (
                      <p>
                        <strong>Location:</strong>{" "}
                        {scannedData.location.latitude},{" "}
                        {scannedData.location.longitude}
                      </p>
                    )}
                  </div>
                  <div className="border-t pt-4">
                    <h3 className="text-lg font-semibold mb-4">ID Card</h3>
                    <IDCard
                      type={scannedData.type}
                      data={scannedData}
                      variant={"style1"}
                      color={"blue"}
                    />
                  </div>
                </div>
              ) : (
                <Card className="w-full">
                  <div className="space-y-4">
                    <p>
                      <strong>Type:</strong> {scannedData.type}
                    </p>
                    <p>
                      <strong>Scan Time:</strong>{" "}
                      {format(scannedData.scanTime, "PPpp")}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      <span className="capitalize">{scannedData.status}</span>
                    </p>
                    {scannedData.location && (
                      <div>
                        <p>
                          <strong>Location:</strong>
                        </p>
                        <p>Latitude: {scannedData.location.latitude}</p>
                        <p>Longitude: {scannedData.location.longitude}</p>
                      </div>
                    )}
                    {scannedData.rules && (
                      <div>
                        <p>
                          <strong>Attendance Rules:</strong>
                        </p>
                        <ul className="list-disc pl-5">
                          {scannedData.rules.map(
                            (rule: AttendanceRule, index: number) => (
                              <li key={index}>
                                {rule.name}: {rule.startTime} - {rule.endTime}
                              </li>
                            )
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                </Card>
              )}
            </div>
          )}
        </Modal>
      </div>
    </div>
  );
};

export default AdminAttendance;
